module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 12,
      "lg": 12
    }
  }, [(_vm.$store.getters.login_type != 'distributor') ? _c('shop-select', {
    attrs: {
      "distributors": ""
    },
    on: {
      "update": _vm.storeSearch
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "start-placeholder": "开始日期",
      "ange-separator": "至",
      "end-placeholder": "结束日期",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围",
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.create_time),
      callback: function($$v) {
        _vm.create_time = $$v
      },
      expression: "create_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 7,
      "lg": 5
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择订单类型",
      "size": "mini"
    },
    on: {
      "change": _vm.TypeHandle
    },
    model: {
      value: (_vm.order_class),
      callback: function($$v) {
        _vm.order_class = $$v
      },
      expression: "order_class"
    }
  }, _vm._l((_vm.order_class_array), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 7,
      "lg": 5
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "请输入来源",
      "size": "mini"
    },
    on: {
      "select": _vm.sourceSearch
    },
    model: {
      value: (_vm.source_name),
      callback: function($$v) {
        _vm.source_name = $$v
      },
      expression: "source_name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 7,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "导购员手机号",
      "size": "mini"
    },
    model: {
      value: (_vm.salesman_mobile),
      callback: function($$v) {
        _vm.salesman_mobile = $$v
      },
      expression: "salesman_mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 7,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号/订单号",
      "size": "mini"
    },
    model: {
      value: (_vm.identifier),
      callback: function($$v) {
        _vm.identifier = $$v
      },
      expression: "identifier"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "md": 6,
      "lg": 5
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportData('normal_master_order')
      }
    }
  }, [_vm._v("导出主订单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportData('normal_order')
      }
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "订单下载",
      "visible": _vm.downloadView,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.downloadView = $event
      }
    }
  }, [(_vm.downloadUrl) ? [_c('a', {
    attrs: {
      "href": _vm.downloadUrl,
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.downloadName))])] : _vm._e()], 2), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "all"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待发货",
      "name": "notship"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已完成",
      "name": "done"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "未支付",
      "name": "notpay"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "取消待审核",
      "name": "cancelapply"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已取消",
      "name": "cancel"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 190,
      "element-loading-text": "数据加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "order_id",
      "width": "150",
      "label": "订单号",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "width": "160",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.create_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 2176513052)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distributor_name",
      "label": "所属店铺"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.distributor_name) ? _c('span', [_vm._v(_vm._s(scope.row.distributor_name))]) : _c('span', [_vm._v("总部")])]
      }
    }], null, false, 3711804642)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "70",
      "label": "运费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.fee_symbol) + _vm._s(scope.row.freight_fee / 100) + "\n          ")]
      }
    }], null, false, 3107920480)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_fee",
      "width": "70",
      "label": "金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.fee_symbol) + _vm._s(scope.row.total_fee / 100) + "\n          ")]
      }
    }], null, false, 4222832577)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "width": "110",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "90",
      "label": "订单类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.order_class == 'normal') ? _c('span', [_vm._v("普通订单")]) : _vm._e(), _vm._v(" "), (scope.row.order_class == 'groups') ? _c('span', [_vm._v("团购订单")]) : _vm._e(), _vm._v(" "), (scope.row.order_class == 'seckill') ? _c('span', [_vm._v("秒杀订单")]) : _vm._e(), _vm._v(" "), (scope.row.order_class == 'community') ? _c('span', [_vm._v("社区订单")]) : _vm._e()]
      }
    }], null, false, 441669766)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_status",
      "label": "订单状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.order_status == 'PAYED') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已支付")]) : (scope.row.order_status == 'NOTPAY') ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("未支付")]) : (scope.row.order_status == 'CANCEL') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("已取消")]) : (scope.row.order_status == 'WAIT_BUYER_CONFIRM') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("待收货")]) : _vm._e(), _vm._v(" "), (scope.row.order_status != 'CANCEL') ? [(scope.row.delivery_status == 'DONE') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已发货")]) : (scope.row.delivery_status == 'PARTAIL') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("部分发货")]) : (scope.row.ziti_status == 'PENDING') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("待自提")]) : (scope.row.ziti_status == 'DONE') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("已自提")]) : (scope.row.cancel_status == 'WAIT_PROCESS') ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(" 取消待退款")]) : _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("待发货")])] : _vm._e()]
      }
    }], null, false, 3961125385)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source_name",
      "label": "来源"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              path: _vm.matchHidePage('detail'),
              query: {
                orderId: scope.row.order_id,
                resource: _vm.$route.path
              }
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), (scope.row.receipt_type == 'logistics' && scope.row.order_status == 'PAYED' && scope.row.delivery_status != 'DONE') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.deliveryAction(scope.row.order_id)
            }
          }
        }, [_vm._v("发货")]) : _vm._e(), _vm._v(" "), (scope.row.cancel_status == 'WAIT_PROCESS' && scope.row.order_status == 'PAYED') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.confirmCancelOrderAction(scope.row.order_id)
            }
          }
        }, [_vm._v("退款")]) : _vm._e()]
      }
    }], null, false, 1172608246)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.deliveryTitle,
      "visible": _vm.deliveryVisible,
      "before-close": _vm.handleCancel,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.deliveryVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "deliveryForm",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.deliveryForm,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "订单号"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_vm._v(_vm._s(_vm.deliveryData.orderInfo.order_id))])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "发货类型"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "disabled": _vm.IsDisabled
      },
      model: {
        value: (_vm.deliveryForm.delivery_type),
        callback: function($$v) {
          _vm.$set(_vm.deliveryForm, "delivery_type", $$v)
        },
        expression: "deliveryForm.delivery_type"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "batch"
      }
    }, [_vm._v("整单发货")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "sep"
      }
    }, [_vm._v("拆分发货")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "商品信息"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 30
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.deliveryData.orderInfo.items
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "item_name",
        "label": "商品名",
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "num",
        "label": "数量",
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "总价(元)"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v(_vm._s(scope.row.fee_symbol) + _vm._s(scope.row.total_fee / 100))])]
        }
      }], null, false, 407753050)
    }), _vm._v(" "), (_vm.deliveryForm.delivery_type == 'sep') ? [_c('el-table-column', {
      attrs: {
        "label": "快递公司",
        "width": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-select', {
            attrs: {
              "filterable": "",
              "placeholder": "请选择快递公司，可搜索"
            },
            model: {
              value: (scope.row.delivery_corp),
              callback: function($$v) {
                _vm.$set(scope.row, "delivery_corp", $$v)
              },
              expression: "scope.row.delivery_corp"
            }
          }, _vm._l((_vm.dlycorps), function(item) {
            return _c('el-option', {
              key: item.value,
              attrs: {
                "label": item.name,
                "value": item.value
              }
            })
          }), 1)]
        }
      }], null, false, 1397891712)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "物流单号",
        "width": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "maxlength": 20,
              "placeholder": "物流公司单号"
            },
            model: {
              value: (scope.row.delivery_code),
              callback: function($$v) {
                _vm.$set(scope.row, "delivery_code", $$v)
              },
              expression: "scope.row.delivery_code"
            }
          })]
        }
      }], null, false, 2798900684)
    })] : _vm._e()], 2)], 1)], 1), _vm._v(" "), (_vm.deliveryForm.delivery_type == 'batch') ? [_c('el-form-item', {
      attrs: {
        "label": "快递公司"
      }
    }, [_c('el-col', [_c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "请选择快递公司，可搜索"
      },
      model: {
        value: (_vm.deliveryForm.delivery_corp),
        callback: function($$v) {
          _vm.$set(_vm.deliveryForm, "delivery_corp", $$v)
        },
        expression: "deliveryForm.delivery_corp"
      }
    }, _vm._l((_vm.dlycorps), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.name,
          "value": item.value
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "物流单号"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 20,
        "placeholder": "物流公司单号"
      },
      model: {
        value: (_vm.deliveryForm.delivery_code),
        callback: function($$v) {
          _vm.$set(_vm.deliveryForm, "delivery_code", $$v)
        },
        expression: "deliveryForm.delivery_code"
      }
    })], 1)], 1)] : _vm._e()], 2)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitDeliveryAction
      }
    }, [_vm._v("确定")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "取消订单退款审核",
      "visible": _vm.cancelVisible,
      "before-close": _vm.handleCancelOrderCancel,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.cancelVisible = $event
      }
    }
  }, [
    [_c('el-row', {
      attrs: {
        "gutter": 100
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', {
      staticClass: "grid-content"
    }, [_vm._v("订单号:" + _vm._s(_vm.cancelData.order_id))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [(_vm.cancelData.cancel_from == 'buyer') ? _c('span', [_vm._v("取消来源:消费者申请")]) : _c('span', [_vm._v("取消来源:系统自动取消")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("申请时间:" + _vm._s(_vm._f("datetime")(_vm.cancelData.create_time, 'yyyy-MM-dd hh:mm:ss')))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("退款状态:")]), _vm._v(" "), (_vm.cancelData.refund_status == 'WAIT_CHECK') ? _c('span', [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.refund_status == 'FAILS') ? _c('span', [_vm._v("退款失败")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.refund_status == 'SUCCESS') ? _c('span', [_vm._v("退款成功")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.refund_status == 'SHOP_CHECK_FAILS') ? _c('span', [_vm._v("商家审核不通过")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.refund_status == 'WAIT_REFUND') ? _c('span', [_vm._v("等待退款")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("处理进度:")]), _vm._v(" "), (_vm.cancelData.progress == '0') ? _c('span', [_vm._v("待处理")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.progress == '1') ? _c('span', [_vm._v("已取消")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.progress == '2') ? _c('span', [_vm._v("退款中")]) : _vm._e(), _vm._v(" "), (_vm.cancelData.progress == '3') ? _c('span', [_vm._v("已完成")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("退款金额:" + _vm._s(_vm.cancelData.fee_symbol) + _vm._s(_vm.cancelData.total_fee / 100))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [(_vm.cancelData.pay_type == 'wxpay') ? _c('span', [_vm._v("支付方式:微信支付")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v("取消原因:" + _vm._s(_vm.cancelData.cancel_reason))])])], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form', {
      ref: "cancelForm",
      attrs: {
        "model": _vm.cancelForm,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "处理结果:"
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 20
      }
    }, [
      [_c('el-radio', {
        attrs: {
          "label": "0"
        },
        model: {
          value: (_vm.cancelForm.check_cancel),
          callback: function($$v) {
            _vm.$set(_vm.cancelForm, "check_cancel", $$v)
          },
          expression: "cancelForm.check_cancel"
        }
      }, [_vm._v("不同意")]), _vm._v(" "), _c('el-radio', {
        attrs: {
          "label": "1"
        },
        model: {
          value: (_vm.cancelForm.check_cancel),
          callback: function($$v) {
            _vm.$set(_vm.cancelForm, "check_cancel", $$v)
          },
          expression: "cancelForm.check_cancel"
        }
      }, [_vm._v("同意")])]
    ], 2)], 1)], 1), _vm._v(" "), (_vm.cancelForm.check_cancel == '0') ? _c('el-form-item', {
      attrs: {
        "label": "拒绝原因:"
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 3,
        "placeholder": "请输入拒绝原因"
      },
      model: {
        value: (_vm.cancelForm.shop_reject_reason),
        callback: function($$v) {
          _vm.$set(_vm.cancelForm, "shop_reject_reason", $$v)
        },
        expression: "cancelForm.shop_reject_reason"
      }
    })], 1)], 1)], 1) : _vm._e()], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleCancelOrderCancel.apply(null, arguments)
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.submitCancelConfirmAction
      }
    }, [_vm._v("确定")])], 1)
  ], 2)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-73646924", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73646924"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/trade/normalorders/shopList.vue
// module id = 2823
// module chunks = 0